var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('h3',{staticClass:"mb-4"},[_vm._v("¿Está seguro de que desea archivar este expediente?")]),_c('TextButton',{on:{"click":_vm.confirmArchiving}},[_vm._v(" Confirmar ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }